import layout1 from './Layout1';

const Layouts = {
  layout1,
};

export default Layouts;
